import {useMutation, useQuery, useQueryClient} from 'react-query';
import {deleteNews, getAllNews, postNews, putNews} from '../Api/api';
import {useIntl} from 'react-intl';
import toast from 'react-hot-toast';
import {ApiResponse} from '../../../types/types';
import {News} from '../Types/type';

const QUERY_KEY = 'news';

// Récupère le message d'erreur renvoyé par le backend (ex : conflit de popup), sinon null.
const getServerMessage = (error: any): string | null => error?.response?.data?.message ?? null;

export const useGetNews = () => {
  return useQuery<any, any, ApiResponse<News[]>>(QUERY_KEY, async () => getAllNews());
};

export const useCreateNews = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: postNews,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY).then(() => {
        toast.success(intl.formatMessage({id: 'CONTACT.FORM.SUCCESS'}));
      });
    },
    onError: (error) => {
      toast.error(getServerMessage(error) ?? intl.formatMessage({id: 'CONTACT.FORM.ERROR'}));
    },
  });
};

export const useUpdateNews = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: putNews,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY).then(() => {
        toast.success(intl.formatMessage({id: 'CONTACT.FORM.SUCCESS'}));
      });
    },
    onError: (error) => {
      toast.error(getServerMessage(error) ?? intl.formatMessage({id: 'CONTACT.FORM.ERROR'}));
    },
  });
};

export const useDeleteNews = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: deleteNews,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY).then(() => {});
    },
    onError: () => {
      toast.error(intl.formatMessage({id: 'CONTACT.FORM.ERROR'}));
    },
  });
};
